export const PARTNER_ACTIVE = "PARTNER_ACTIVE";

const initialState = null; 
/*
{
    active: boolean,
}
*/

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PARTNER_ACTIVE:
            return action.payload;
        default:
            return state;
    }
}

const storeMapping = {partnerActive: reducer};

export const partnerActiveSelector = (state) => state.partnerActive;

export default storeMapping;
